import { render } from "./modal-locked-content.vue?vue&type=template&id=2bb180e6&scoped=true"
import script from "./modal-locked-content.vue?vue&type=script&lang=js"
export * from "./modal-locked-content.vue?vue&type=script&lang=js"

import "./modal-locked-content.vue?vue&type=style&index=0&id=2bb180e6&lang=stylus&scoped=true"

import exportComponent from "/var/www/docker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bb180e6"],['__file',"src/components/modal-locked-content.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2bb180e6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2bb180e6', __exports__)) {
    api.reload('2bb180e6', __exports__)
  }
  
  module.hot.accept("./modal-locked-content.vue?vue&type=template&id=2bb180e6&scoped=true", () => {
    api.rerender('2bb180e6', render)
  })

}


export default __exports__